import { render, staticRenderFns } from "./ConfigAlertMattermost.vue?vue&type=template&id=03563410&"
import script from "./ConfigAlertMattermost.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertMattermost.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAlertMattermost.vue?vue&type=style&index=0&id=03563410&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports